/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountIsShadowQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountIsShadowQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isShadow: boolean } | null };


export const AccountIsShadowDocument = gql`
    query AccountIsShadow($accountId: AccountId!) {
  account(id: $accountId) {
    id
    isShadow
  }
}
    `;

/**
 * __useAccountIsShadowQuery__
 *
 * To run a query within a React component, call `useAccountIsShadowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountIsShadowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountIsShadowQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountIsShadowQuery(baseOptions: Apollo.QueryHookOptions<AccountIsShadowQuery, AccountIsShadowQueryVariables> & ({ variables: AccountIsShadowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountIsShadowQuery, AccountIsShadowQueryVariables>(AccountIsShadowDocument, options);
      }
export function useAccountIsShadowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountIsShadowQuery, AccountIsShadowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountIsShadowQuery, AccountIsShadowQueryVariables>(AccountIsShadowDocument, options);
        }
export function useAccountIsShadowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountIsShadowQuery, AccountIsShadowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountIsShadowQuery, AccountIsShadowQueryVariables>(AccountIsShadowDocument, options);
        }
export type AccountIsShadowQueryHookResult = ReturnType<typeof useAccountIsShadowQuery>;
export type AccountIsShadowLazyQueryHookResult = ReturnType<typeof useAccountIsShadowLazyQuery>;
export type AccountIsShadowSuspenseQueryHookResult = ReturnType<typeof useAccountIsShadowSuspenseQuery>;
export type AccountIsShadowQueryResult = Apollo.QueryResult<AccountIsShadowQuery, AccountIsShadowQueryVariables>;